import { useGetRequest } from "@ch/api/useGetRequest";
import { type Frequency, FrequencyControllerService } from "@ch/generated";
import { useState } from "react";

const useFrequenciesGet = () => {
  const [frequencies, setFrequencies] = useState<Frequency[]>([]);

  const { loading } = useGetRequest({
    service: FrequencyControllerService.frequencyControllerFind.bind(
      FrequencyControllerService,
    ),
    tag: "frequencyControllerFind",
    payload: {},
    onSuccess: (data: Frequency[]) => {
      setFrequencies(data);
    },
  });

  return {
    loadingFrequencies: loading,
    frequencies,
  };
};

export default useFrequenciesGet;
